var map = {
	"./404.json": 7207,
	"./account.json": 8831,
	"./blockbuster.json": 4001,
	"./cinema.json": 3729,
	"./faq.json": 9585,
	"./footer.json": 4881,
	"./header.json": 7039,
	"./index.json": 2859,
	"./info.json": 5206,
	"./privacy.json": 6447,
	"./schools.json": 8038,
	"./sign-in.json": 8251,
	"./subreader-ambassadoer.json": 2324,
	"./subscription.json": 6987,
	"./terms.json": 6078
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2735;